module.exports = __webpack_public_path__ + "static/img/ins.7e907bff.svg";